import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/client.actions';
import * as actionssession from '../../../../actions/session.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import FilterMenu from './FilterMenu';
import List from './List';
import Error from '../../../dialogs/Error';
import ClientsDialog from './ClientsDialog';
import Snackbar from '../../../labels/Snackbar';
import { AddIcon, LinkIcon } from '../../../../images/icons/WrapSvg';

/*
function toolbar(handleFilter) {
    return <FilterIcon key={'filter-menu-toolbar'} color={'primary'} onClick={handleFilter} />;
}
*/

class Employees extends React.Component {
    state = {
        hide: false,
        open: undefined,
        openDialog: false,
        all_employees: true,
        error: undefined,
    };

    constructor(props) {
        super(props);
        props.loadClients();
        this.props.setSearch(true);
    }

    componentDidMount() {
        this.props.setInventoryWindow("customers");
    }

    componentWillUnmount() {
        this.props.setSearch(false);
    }

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (option) => {
        switch (option) {
            case 'employees':
                this.setState({ open: undefined, all_employees: !this.state.all_employees });
                break;
            default:
                this.setState({ open: undefined });
                break;
        }
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = (event) => {
        this.props.history.push('/manage/new_customer');
    };

    handleClickDialog = (event) => {
        this.setState({ openDialog: true });
    };

    handleCloseDialog = (client) => {
        console.log(client);
        if (client) {
            this.props
                .changeActiveClient(client)
                .then(() => {
                    this.props.logOutUser();
                })
                .catch((error) => this.setState({ error: error.message }));
        }
        this.setState({ openDialog: false });
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !info.security.totalPermits.some((f) => f === '20')
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            const { open, openDialog, all_employees, error } = this.state;
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={4} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div
                            className={
                                'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'
                            }
                        >
                            <List
                                search={[...this.props.window_searchs]}
                                all_employees={all_employees}
                            />
                            {info &&
                                info.security &&
                                info.security.totalPermits &&
                                info.security.totalPermits.some(
                                    (f) => f === '20' || f === '61',
                                ) && (
                                    <Fab
                                        color="secondary"
                                        aria-label="link"
                                        className={'button_float_over'}
                                        onClick={this.handleClickDialog}
                                    >
                                        <LinkIcon />
                                    </Fab>
                                )}
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                    {open && (
                        <FilterMenu
                            active={all_employees}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                    {openDialog && <ClientsDialog onClose={this.handleCloseDialog} />}
                    {error && (
                        <Snackbar
                            open={error ? true : false}
                            variant="error"
                            text={error}
                            onClose={this.handleCloseError}
                        />
                    )}
                </div>
            );
        }
    }
}

Employees.propTypes = {
    clients_is_loading: PropTypes.bool.isRequired,
    window_searchs: PropTypes.array.isRequired,
    session: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        clients_is_loading: state.clients_is_loading,
        window_searchs: state.window_searchs,
        session: state.session,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionssession, home, inventory), dispatch);
};

Employees = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Employees);

Employees = withRouter(Employees);

export default Employees;



// WEBPACK FOOTER //
// ./src/components/complex/manage/customers/Index.js